<template>


  <ul class="list-none p-2 m-0">
    <li>
      <router-link to="/mod-orders/orders" v-ripple class="no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="pi pi-book mr-2"></i> 
            <span class="font-medium">OBJEDNÁVKY</span>
      </router-link>
      
    </li>

    <li v-if="store.user.department.id != 1">
      <div v-ripple class="flex align-items-center p-3 border-round text-500 p-ripple">
        <i class="pi pi-comments mr-2"></i> 
        <span class="font-medium">KOMUNIKÁCIA</span>
      </div>
      <ul class="list-none p-1 ml-4">
        <li>
          <router-link to="/mod-orders/messages/1/0" v-ripple class="no-underline flex align-items-center cursor-pointer pt-1 pl-2 pb-2 pr-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="pi pi-envelope mr-2"></i> 
            <span class="font-medium">Neprečítané</span>
            <span v-if="unreadRecords" class="inline-flex align-items-center justify-content-center ml-auto bg-blue-400 text-0 border-circle" 
                  style="min-width: 1.5rem; height: 1.5rem;">{{unreadRecords}}</span>
          </router-link>
        </li>
        <li>
          <router-link to="/mod-orders/messages/2/0" v-ripple class="no-underline flex align-items-center cursor-pointer p-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="pi pi-file-excel mr-2"></i> 
            <span class="font-medium">Nezatriedené</span>
            <span v-if="unassignedRecords" class="inline-flex align-items-center justify-content-center ml-auto bg-blue-400 text-0 border-circle" 
                  style="min-width: 1.5rem; height: 1.5rem;">{{unassignedRecords}}</span>
          </router-link>
        </li>                  
      </ul>
    </li>

    <li v-if="store.user.department.id != 1">
      <div v-ripple class="flex align-items-center p-3 border-round text-500 p-ripple">
        <i class="pi pi-arrow-circle-down mr-2"></i> 
        <span class="font-medium">DODÁVATELIA</span>
      </div> 

      <ul class="list-none p-1 ml-4">
        <li v-for="s in this.store.suppliers" v-bind:key="s.id">
          <router-link :to="'/mod-orders/messages/3/'+s.id" v-ripple class="no-underline flex align-items-center cursor-pointer p-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="pi pi-warehouse mr-2"></i>
            <span class="font-medium">{{s.company}}</span>
            <span v-if="supplierRecords.get(s.id)" class="inline-flex align-items-center justify-content-center ml-auto bg-red-400 text-0 border-circle" 
                  style="min-width: 1.5rem; height: 1.5rem;">{{supplierRecords.get(s.id)}}</span>
          </router-link> 
        </li>
      </ul>               
    </li>

    <li v-if="store.user.department.id != 1">
      <div v-ripple class="flex align-items-center p-3 border-round text-500 p-ripple">
        <i class="pi pi-bookmark mr-2"></i> 
        <span class="font-medium">ZNAČKY</span>
      </div>  

      <ul class="list-none p-1 ml-4">
        <li  v-for="m in this.store.marks" v-bind:key="m.id">
          <router-link :to="'/mod-orders/messages/4/'+m.id" v-ripple class="no-underline flex align-items-center cursor-pointer pt-1 pl-2 pb-2 pr-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="pi pi-bookmark mr-2"></i> 
            <span class="font-medium">{{m.name}}</span>
            <span v-if="markRecords.get(m.id)" class="inline-flex align-items-center justify-content-center ml-auto bg-blue-400 text-0 border-circle" 
                  style="min-width: 1.5rem; height: 1.5rem;">{{markRecords.get(m.id)}}</span>
          </router-link>
        </li>
      </ul>
    </li>  
    
    <li>
      <router-link v-if="store.token != '' && store.user.admin === true" to="/mod-orders/ignored_emails" v-ripple 
          class="no-underline flex align-items-center cursor-pointer p-3 border-round text-700 
                hover:surface-100 transition-duration-150 transition-colors p-ripple">
          <i class="pi pi-envelope mr-2"></i> 
          <span class="font-medium">IGNOROVANÉ EMAILY</span>
      </router-link>
      
    </li>

  </ul>


</template>

<script lang="ts">
import {store} from "@/components/store";
import Security from './security';
import notie from "notie/dist/notie";
import Utils from '@/components/utils';
import {emiter} from '../main';

export default {
  name: "ManageOrders",
  components:{
 
  },
  data() {
    return {
      store,
      //supplier: [],
      interval: null,
      unreadRecords: 0,
      unassignedRecords: 0,
      supplierRecords: new Map(),
      markRecords: new Map(),
    }
  },
  computed: {
    Utils() {
      return Utils
    },
  },
  beforeMount() {
    if (Security.requireToken()){
       store.selectModul = this.$route.path.split("/")[1]
       Utils.getAttTypes()
       this.fetchData()
    }
  },
  beforeUnmount() {
  //  this.stopCountingMessages()
    emiter.off('reload',this.getCountOfMessages);
  },
  methods: {
    fetchData(){
        fetch(this.store.Api_url + "/v1/supplier", Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              //this.$emit('error', responseData.data);
              notie.alert({
                type: 'error',
                text: "Zoznam dodávateľov sa nepodarilo načítať"
              })
            } else {
              //console.log('Suppliers', responseData);
              store.suppliers = responseData.data;
              //this.getCountOfMessages();
                fetch(this.store.Api_url + "/v1/mark", Security.requestOptions("GET"))
                  .then((response) => response.json())
                  .then((responseData) => {
                    if (responseData.error) {
                      //this.$emit('error', responseData.data);
                      notie.alert({
                        type: 'error',
                        text: "Zoznam značiek sa nepodarilo načítať"
                      })
                    } else {
                      
                      store.marks = responseData.data;
                      this.startCountingMessages();
                      //console.log('Marks: ', store.marks);
                    }
                  })
                  .catch((error) => {
                    this.$emit('error', "Chyba pri načítaní značiek" + error);
              });
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri načítaní dodávateľov" + error);
      });
    

    },
    startCountingMessages(){
      this.getCountOfMessages();
      //this.interval = setInterval(this.getCountOfMessages, 60000);
      emiter.on('reload',this.getCountOfMessages);
    },

    getCountOfMessages(){

       //emiter.emit("reload","reload")

        Utils.getMessageCount({typ:'2',id:'0'}).then((a:number) => {
          this.unassignedRecords = a;
        });

        Utils.getMessageCount({typ:'1',id:'0'}).then((a:number) => {
          this.unreadRecords = a;
        });
        //console.log('Reload 1');

        store.suppliers.forEach((s) => {
          Utils.getMessageCount({typ:'3',id:s.id}).then((value:number) => {
            this.supplierRecords.set(s.id, value);
          });
          //console.log('Supplier:', s.id);
        });

        store.marks.forEach((m) => {
          Utils.getMessageCount({typ:'4',id:m.id}).then((value:number) => {
            this.markRecords.set(m.id, value);
          });
          //console.log('Mark:', m.id);
        })
    },


  }
}
</script>
<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
</style>